import { SitecoreMediaItem } from '../models';

/**
 * Type guard to check if a value is a SitecoreMediaItem.
 *
 * @param field - The value to check.
 * @returns True if the value is a SitecoreMediaItem, otherwise false.
 */
export const isMediaItem = (field: unknown): field is SitecoreMediaItem => {
  if (typeof field !== 'object' || field === null) return false;

  const record = field as Record<string, unknown>;
  return (
    typeof record['url'] === 'string' &&
    typeof record['name'] === 'string' &&
    typeof record['fields'] === 'object' &&
    record['fields'] !== null &&
    'Alt' in (record['fields'] as object) &&
    'Title' in (record['fields'] as object)
  );
};
